var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subtitle text-center"
  }, [_c('div', {
    staticClass: "title font-weight-bold mx-8"
  }, [_vm._v(_vm._s(_vm.event.name))]), _vm.event.details ? _c('div', {
    ref: "details",
    staticClass: "preserve-newlines"
  }, [_vm._v(_vm._s(_vm.event.details))]) : _vm._e(), _vm.event.location || !_vm.event.is_virtual && _vm.event.address || _vm.event.url_map || _vm.event.url_virtual ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.event.location ? _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.event.location))]) : _vm._e(), !_vm.event.is_virtual && _vm.event.address ? _c('div', [_vm._v(_vm._s(_vm.event.address))]) : _vm._e(), _vm.event.url_map || _vm.event.url_virtual ? _c('div', {
    staticClass: "mx-n2"
  }, [_vm.event.url_map ? _c('a', {
    staticClass: "ma-2",
    attrs: {
      "target": "_blank",
      "href": _vm.event.url_map
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMapMarker)
    }
  }), _vm._v("Map link")], 1) : _vm._e(), _vm.event.url_virtual ? _c('a', {
    staticClass: "ma-2",
    attrs: {
      "target": "_blank",
      "href": _vm.event.url_virtual
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMonitorAccount)
    }
  }), _vm._v("Virtual event link ")], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm.event.lz_date || _vm.event.lz_time_range || _vm.event.from ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.event.lz_date ? _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.event.lz_date))]) : _vm._e(), _vm.event.lz_time_range ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.event.lz_time_range))]), _c('span', {
    staticClass: "ml-1 text--label-active grey--text"
  }, [_vm._v(_vm._s(_vm.event.lz_tz_name))])]) : _vm._e(), _vm.event.from ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-calendar');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendarPlus)
    }
  }), _vm._v("Add to calendar")], 1) : _vm._e()]) : _vm._e(), _vm.event.public_guest_list ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.totals ? _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Total attending: "), _vm.totalsLoading ? [_vm._v("…")] : [_vm._v(_vm._s(_vm.totals['Attending'])), _vm.event.form.separate_counts ? [_vm._v(" (" + _vm._s(_vm.totals['Adults']) + " adult" + _vm._s(_vm.totals['Adults'] == 1 ? '' : 's') + ", " + _vm._s(_vm.totals['Children']) + " " + _vm._s(_vm.totals['Children'] == 1 ? 'child' : 'children') + ")")] : _vm._e()]], 2) : _vm._e(), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-guest-list');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccountGroup)
    }
  }), _vm._v("Show guest list")], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }